import Axios from "../../../../api/axios/Axios";

export const getCreatorChannelAlbums = async (
  username,
  { limit = 12, offset = 0 } = {},
) => {
  const encodedUsername = encodeURIComponent(username);

  return Axios.get(`/api/channels/${encodedUsername}/albums`, {
    params: {
      limit,
      offset,
    },
  });
};

export const getCreatorChannelAlbumPhotos = async (
  username,
  albumId,
  { limit = 24, offset = 0 } = {},
) => {
  const encodedUsername = encodeURIComponent(username);
  const encodedAlbumId = encodeURIComponent(albumId);

  return Axios.get(
    `/api/channels/${encodedUsername}/albums/${encodedAlbumId}/photos`,
    {
      params: {
        limit,
        offset,
      },
    },
  );
};
